// extracted by mini-css-extract-plugin
export default {"container":"style_container__xC7Dg","innerBox":"style_innerBox__WTMZ3","imageBox":"style_imageBox__BPgkT","description":"style_description__pVNlJ","link":"style_link__JTsz-"};